export const STRING = "STRING";
export const TEXTAREA = "TEXTAREA";
export const NUMBER = "NUMBER";
export const SELECT = "SELECT";
export const IMAGE = "IMAGE";
export const DATE = "DATE";
export const PHONE = "PHONE";
export const RADIO = "RADIO";
export const CHECKBOX = "CHECKBOX";
export const TEXTBLOCK = "TEXTBLOCK";
export const LABEL2 = "LABEL2";
export const MODALTABLE = "MODALTABLE";
export const BUTTON_MIJOZ = "BUTTON_MIJOZ";
export const MIJOZ_OTKAZ = "MIJOZ_OTKAZ";
export const COSTUM = "COSTUM";
export const FILE = "FILE";
export const CURRENCY = "CURRENCY";
export const MAP = "MAP";
export const MAPLATLNG = "MAPLATLNG";
